import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  '@global': {
    '.MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  headerRow: {
    backgroundColor: '#F5F5F5',
    height: '55px',
  },

  headerCell: {
    fontFamily: 'Readex Pro',
    fontWeight: 600,
    fontSize: '14px',
    color: '#0F0F0F',
    padding: '0 16px',
    // Remove borderRight for table cells

    '&:last-child': {
      borderRight: 'none',
    },
  },

  sortableHeader: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',

    '&:hover': {
      opacity: 0.8,
    },
  },

  sortIcon: {
    marginLeft: '4px',
    padding: '2px',

    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      color: '#0F0F0F',
    },
  },

  // Responsive design
  '@media (max-width: 960px)': {
    headerCell: {
      fontSize: '12px',
      padding: '0 12px',
    },
  },

  '@media (max-width: 600px)': {
    headerCell: {
      fontSize: '11px',
      padding: '0 8px',
    },
  },
}));

export default useStyles;
